<!-- 多选组件 -->
<template>
  <div>
    <div class="chat-card" v-for="(item, index) in checkboxList" :key="index">
      <div class="chat-title">
        <span class="title-icon">“</span>
        <div class="title">
          {{ item.title }}
        </div>
      </div>
      <div class="checkbox-list">
        <div
          class="checkbox-item"
          v-for="(itemTag, indexTag) in item.selectValArr"
          :key="'tag' + indexTag"
          @click="selectItem(itemTag)"
        >
          <div class="checkbox-item-box">
            {{ itemTag.label }}
            <icon v-if="selectList.includes(itemTag.label)" class="checked-icon" name="success" color="#43CF7C" />
          </div>
        </div>
      </div>
    </div>
    <button v-if="isCanEdit" class="confirm-btn" @click="confirmFn">确定</button>
    <!-- <div class="send-time">09月01日 16:29</div> -->
    <PopupCard ref="PopupRef" :infoText="infoText"></PopupCard>
  </div>
</template>

<script>
import { Icon } from 'vant';
import PopupCard from '@/components/PopupCard/index.vue';
import { dictDataType } from '@/api/app'

export default {
  name: 'ChatCheckbox',
  components: { Icon, PopupCard },
  props: {
    cardData: {
      type: Object,
      default: () => {
        return null;
      },
    },
    // 是否可编辑
    isCanEdit: {
      type: Boolean,
      default: true,
    },
    nextData: {
      type: Object,
      default: () => {
        return null;
      },
    }
  },
  data() {
    return {
      infoText: '哦~你未选择问题<br>请至少选择一个问题哦！',
      checkboxList: [],
      selectList: []
    };
  },
  created() {},
  mounted() {
    this.getDictDataType()
    if(this.nextData?.step_data?.survey?.qstList[0].answer.tags) {
      let useData = this.nextData.step_data.survey.qstList[0].answer.tags;
      this.selectList = useData;
    }
  },
  methods: {
    // 查询 大类 子集
    getDictDataType() {
      dictDataType('youth_troubles_category').then(res => {
        console.log('youth_troubles_category', res);
        this.checkboxList = res.map(item => {
          return {
            title: item.label,
            selectValArr: JSON.parse(item.value).map(value => {
              return {
                label: value
              }
            })
          }
        })
      })
    },
    selectItem(tag) {
      if(!this.isCanEdit) {
        return;
      }
      if(tag.label === '不存在上述问题') {
        this.selectList = ['不存在上述问题']
        return;
      }
      const findIndex = this.selectList.findIndex(item => item === tag.label);
      const noProblemIndex = this.selectList.findIndex(item => item === '不存在上述问题');
      if(findIndex === -1) {
        this.selectList.push(tag.label);
        if(noProblemIndex !== -1) {
          this.selectList.splice(noProblemIndex, 1);
        }
      } else {
        this.selectList.splice(findIndex, 1);
      }
    },
    
    confirmFn() {
      if(!this.selectList.length) {
        this.$refs.PopupRef.isShow = true;
        return;
      }
      const categories = []
      this.checkboxList.forEach(item => {
        let exists = this.selectList.some(value => item.selectValArr.some(obj => obj.label === value));
        if(exists) {
          categories.push(item.title);
        }
      })
      const useData = {
        id: this.cardData.id,
        step_id: this.cardData.step_id,
        step_data: {
          survey: {
            id: this.cardData.instance_id,
            surveyType: 2,
            qstList: [
              {
                qstCode: 'trouble_category_qst',
                answer: { categories: categories, tags: this.selectList },
              },
            ],
          },
          store: { trouble_categories: this.selectList },
        },
      };
      this.$emit('confirmFn', useData);
    },
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  width: 342px;
  border-radius: 12px;
  padding: 16px 12px;
  background: #f2f8fc;
  box-sizing: border-box;
  margin-bottom: 20px;
  border: 1px solid #cfecff;
  .chat-title {
    position: relative;
    width: 100%;
    height: 22px;
    margin-bottom: 6px;
    .title-icon {
      text-align: center;
      vertical-align: middle;
      display: block;
      font-size: 60px;
      position: absolute;
      z-index: 9;
      top: 11px;
      left: -4px;
      color: #cfecff;
      width: 22px;
      line-height: 20px;
    }
    .title {
      font-size: 16px;
      font-weight: 600;
      color: rgba(18, 18, 18, 1);
      position: absolute;
      z-index: 99;
      top: 0px;
      left: 0px;
      line-height: 22px;
    }
  }
  .checkbox-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr); /* 创建四列，每列等宽 */
    grid-gap: 8px; /* 行和列之间的间隔 */

    .checkbox-item {
      .checkbox-item-box {
        border-radius: 3px;
        background: #ffffff;
        line-height: 14px;
        font-size: 10px;
        font-weight: 400;
        color: rgba(18, 18, 18, 0.4);
        padding: 4px 12px 4px 4px;
        box-sizing: border-box;
        position: relative;

        .checked-icon {
          width: 8px;
          height: 8px;
          position: absolute;
          right: 4px;
          bottom: 4px;
        }
      }
    }
  }
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9d9fa3;
  margin-top: 4px;
}

.confirm-btn {
  width: 76px;
  height: 25px;
  border-radius: 12.66px;
  background: #3895ff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.23px;
  color: rgba(255, 255, 255, 1);
  border: none;
  margin: 10px auto 0;
}
</style>
